import { createAction, props } from '@ngrx/store';

import { IBulkDeleteErrorResponse } from '../../../../../../../data/engagement/engagement-models/src/lib/dto/response-dto/bulk-delete';

export const deleteProductList = createAction(
  '[ProductList] Delete List',
  props<{ id: string }>(),
);

export const bulkDeleteLists = createAction(
  '[ProductList] Bulk Delete Lists',
  props<{ ids: string[] }>(),
);

export const bulkDeleteListsSuccess = createAction(
  '[ProductList] Bulk Delete Lists Success',
  props<{ ids: string[] }>(),
);

export const bulkDeleteListsSuccessFinalize = createAction(
  '[ProductList] Bulk Delete Lists Success Finalize',
  props<{ ids: string[] }>(),
);

export const bulkDeleteListsFail = createAction(
  '[ProductList] Bulk Delete Lists Fail',
);

export const confirmBulkDeleteListsWithLookBook = createAction(
  '[ProductList] Confirm Bulk Delete Lists With LookBook',
  props<{
    ids: string[];
    failedDeletingProductLists: IBulkDeleteErrorResponse[];
  }>(),
);
